import axios, { AxiosResponse, AxiosError } from "axios";

import { ApiGenericResponse } from "./ApiGenericResponse";
import { LocalStorageManager, LocalStorageRequests } from "@/plugins/LocalStorageManager";

const origin = window.location.origin;
const path = window.parent.location.pathname.split("/")[1];
export const API_PREFIX = "api";
export const API_VERSION = "/v2";

export type HttpVerbType = "get" | "post" | "delete" | "put" | "patch";
export type HttpResponseType = "arraybuffer" | "blob" | "document" | "json" | "text" | "stream";

export abstract class Command {
    abstract endPoint: string;
    abstract httpVerb: HttpVerbType;
    responseType: HttpResponseType = null;

    protected async executeCommand(payload?: any, extraHeaders?: any, params?: any): Promise<AxiosResponse> {
        let finalEndpoint: string = "";

        if (process.env.NODE_ENV == "development") {
            finalEndpoint = `/${this.endPoint}`;
        } else {
            finalEndpoint = `${origin}/${path}/${this.endPoint}`;
        }

        let jwtToken = LocalStorageManager.Read(LocalStorageRequests.JwtToken);

        let res: AxiosResponse;
        try {
            res = await axios({
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                    ...extraHeaders,
                },
                method: this.httpVerb,
                url: finalEndpoint,
                data: payload,
                params: params,
                responseType: this.responseType,
            });
            return res;
        } catch (err) {
            const error: AxiosError = err;
            let response = new ApiGenericResponse(error.response);
            console.warn("Error executing command - Parsed obj: ", response);
            return error.response;
        }
    }
}
